<template>
    <div>
        <b-alert v-if="trainingPower !== 1" show variant="primary" class="text-center">
            <h5 class="alert-heading">{{ msg }}</h5>
        </b-alert>

        <div class="form-row" v-show="trainingType === 'sop'">
            <div class="col" role="alert" v-show="trainingPower === 1">
                <h5 class="text-center">Занятия ЛФК</h5>
            </div>
            <div class="col" role="alert" v-show="trainingPower === 2">
                <b-form-group class="text-center">
                    <b-form-radio-group id="btn-radios-1" v-model="selected" buttons name="radios-btn">
                        <b-form-radio button-variant="outline-success" name="radios" value="t0">Очень лёгкая - 1
                        </b-form-radio>
                        <b-form-radio button-variant="outline-success" name="radios" value="t1">Очень лёгкая - 2
                        </b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </div>
            <div class="col" role="alert" v-show="trainingPower === 3">
                <b-form-group class="text-center">
                    <b-form-radio-group id="btn-radios-1" v-model="selected" buttons name="radios-btn">
                        <b-form-radio button-variant="outline-primary" name="radios" value="t2">Лёгкая - 1
                        </b-form-radio>
                        <b-form-radio button-variant="outline-primary" name="radios" value="t3">Лёгкая - 2
                        </b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </div>
            <div class="col" role="alert" v-show="trainingPower === 4">
                <b-form-group class="text-center">
                    <b-form-radio-group id="btn-radios-1" v-model="selected" buttons name="radios-btn">
                        <b-form-radio button-variant="outline-info" name="radios" value="t4">Средняя
                        </b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </div>
            <div class="col" role="alert" v-show="trainingPower === 5">
                <b-form-group class="text-center">
                    <b-form-radio-group id="btn-radios-1" v-model="selected" buttons name="radios-btn">
                        <b-form-radio button-variant="outline-warning" name="radios" value="t5">Тяжёлая
                        </b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </div>
        </div>

        <div class="form-row" v-show="trainingType === 'kyad'">
            <div class="col" role="alert" v-show="trainingPower === 1">
                <h5 class="text-center">Занятия ЛФК</h5>
            </div>
            <div class="col" role="alert" v-show="trainingPower === 2">
                <b-form-group class="text-center">
                    <b-form-radio-group id="btn-radios-1" v-model="selected" buttons name="radios-btn">
                        <b-form-radio button-variant="outline-success" name="radios" value="t6">Очень лёгкая
                        </b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </div>
            <div class="col" role="alert" v-show="trainingPower === 3">
                <b-form-group class="text-center">
                    <b-form-radio-group id="btn-radios-1" v-model="selected" buttons name="radios-btn">
                        <b-form-radio button-variant="outline-primary" name="radios" value="t7">Лёгкая
                        </b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </div>
            <div class="col" role="alert" v-show="trainingPower === 4">
                <b-form-group class="text-center">
                    <b-form-radio-group id="btn-radios-1" v-model="selected" buttons name="radios-btn">
                        <b-form-radio button-variant="outline-info" name="radios" value="t8">Средняя
                        </b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </div>
            <div class="col" role="alert" v-show="trainingPower === 5">
                <b-form-group class="text-center">
                    <b-form-radio-group id="btn-radios-1" v-model="selected" buttons name="radios-btn">
                        <b-form-radio button-variant="outline-warning" name="radios" value="t9">Тяжёлая
                        </b-form-radio>
                        <b-form-radio button-variant="outline-danger" name="radios" value="t10">Очень тяжёлая
                        </b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </div>
        </div>

        <div class="form-row" v-show="trainingType === 'ksd'">
            <div class="col" role="alert" v-show="trainingPower === 1">
                <h5 class="text-center">Занятия ЛФК</h5>
            </div>
            <div class="col" role="alert" v-show="trainingPower === 2">
                <b-form-group class="text-center">
                    <b-form-radio-group id="btn-radios-1" v-model="selected" buttons name="radios-btn">
                        <b-form-radio button-variant="outline-success" name="radios" value="t11">Очень лёгкая
                        </b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </div>
            <div class="col" role="alert" v-show="trainingPower === 3">
                <b-form-group class="text-center">
                    <b-form-radio-group id="btn-radios-1" v-model="selected" buttons name="radios-btn">
                        <b-form-radio button-variant="outline-primary" name="radios" value="t12">Лёгкая
                        </b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </div>
            <div class="col" role="alert" v-show="trainingPower === 4">
                <b-form-group class="text-center">
                    <b-form-radio-group id="btn-radios-1" v-model="selected" buttons name="radios-btn">
                        <b-form-radio button-variant="outline-info" name="radios" value="t13">Средняя
                        </b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </div>
            <div class="col" role="alert" v-show="trainingPower === 5">
                <b-form-group class="text-center">
                    <b-form-radio-group id="btn-radios-1" v-model="selected" buttons name="radios-btn">
                        <b-form-radio button-variant="outline-warning" name="radios" value="t14">Тяжёлая
                        </b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </div>
        </div>

        <div class="form-row" v-show="trainingType === 'mixed'">
            <div class="col" role="alert" v-show="trainingPower === 1">
                <h5 class="text-center">Занятия ЛФК</h5>
            </div>
            <div class="col" role="alert" v-show="trainingPower === 2">
                <b-form-group class="text-center">
                    <b-form-radio-group id="btn-radios-1" v-model="selected" buttons name="radios-btn">
                        <b-form-radio button-variant="outline-success" name="radios" value="t15">Очень лёгкая
                        </b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </div>
            <div class="col" role="alert" v-show="trainingPower === 3">
                <b-form-group class="text-center">
                    <b-form-radio-group id="btn-radios-1" v-model="selected" buttons name="radios-btn">
                        <b-form-radio button-variant="outline-primary" name="radios" value="t16">Лёгкая</b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </div>
            <div class="col" role="alert" v-show="trainingPower === 4">
                <b-form-group class="text-center">
                    <b-form-radio-group id="btn-radios-1" v-model="selected" buttons name="radios-btn">
                        <b-form-radio button-variant="outline-info" name="radios" value="t17">Средняя</b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </div>
            <div class="col" role="alert" v-show="trainingPower === 5">
                <b-form-group class="text-center">
                    <b-form-radio-group id="btn-radios-1" v-model="selected" buttons name="radios-btn">
                        <b-form-radio button-variant="outline-danger" name="radios" value="t18">Тяжёлая</b-form-radio>
                    </b-form-radio-group>
                    <b-form-radio-group id="btn-radios-1" v-model="selected" buttons name="radios-btn">
                        <b-form-radio button-variant="outline-danger" name="radios" value="t19">Очень тяжёлая - 1
                        </b-form-radio>
                        <b-form-radio button-variant="outline-danger" name="radios" value="t20">Очень тяжёлая - 2
                        </b-form-radio>
                        <b-form-radio button-variant="outline-danger" name="radios" value="t21">Очень тяжёлая - 3
                        </b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </div>
        </div>
        <TrainingChart v-if="selected" id="training-chart" :iap-value="data.out2iap.iap" :time-minutes="timeMinutes" :hr-min="data.out.hrMin" :hr-max="data.out.hrMax" :training-id="selected"/>
    </div>
</template>

<script>
    import _ from "lodash";
    import Diagnosis from "../Diagnosis";
    import TrainingChart from "../charts/TrainingChart";

    export default {
        components: {
            TrainingChart
        },
        props: {
            data: {
                type: Object,
            }
        },
        computed: {
            trainingType: function () {
                let vm = this;

                let kyadMuscleLevelRate = _.find(Diagnosis.data().muscleLevel, function (d) {
                    return d.is(vm.data.out.kyadMuscleLevel);
                }).rate;
                let ksdMuscleLevelRate = _.find(Diagnosis.data().muscleLevel, function (d) {
                    return d.is(vm.data.out.ksdMuscleLevel);
                }).rate;
                let sopMuscleLevel = _.find(Diagnosis.data().sopMuscleLevel, function (d) {
                    return d.is(vm.data.out.sopMuscleLevel);
                }).rate;
                let minMuscleLevel = Math.min(kyadMuscleLevelRate, ksdMuscleLevelRate, sopMuscleLevel);
                kyadMuscleLevelRate = Math.min(minMuscleLevel + 1, kyadMuscleLevelRate);
                ksdMuscleLevelRate = Math.min(minMuscleLevel + 1, ksdMuscleLevelRate);
                sopMuscleLevel = Math.min(minMuscleLevel + 1, sopMuscleLevel);

                let maxMuscleLevelRate = Math.max(kyadMuscleLevelRate, ksdMuscleLevelRate, sopMuscleLevel);
                let trainingType = 'mixed';

                let mixedTypeCount = 0;
                if (maxMuscleLevelRate === kyadMuscleLevelRate) {
                    trainingType = 'kyad';
                    mixedTypeCount++;
                }
                if (maxMuscleLevelRate === ksdMuscleLevelRate) {
                    trainingType = 'ksd';
                    mixedTypeCount++;
                }
                if (maxMuscleLevelRate === sopMuscleLevel) {
                    trainingType = 'sop';
                    mixedTypeCount++;
                }
                if (mixedTypeCount > 1) {
                    trainingType = 'mixed';
                }
                return trainingType;
            },
            msg: function () {
                return this.find().msg;
            },
            trainingPower: function () {
                let vm = this;
                return _.find(this.sfp, function (d) {
                    return d.is(vm.data.out3sfp.sfp);
                }).rate;
            },
            timeMinutes: function () {
                let vm = this;
                return _.find(this.odv, function (d) {
                    return d.is(vm.data.out.odv);
                }).timeMinutes;
            }
        },
        data() {
            return {
                selected: '',
                display: [
                    {
                        is: function (x) {
                            return x === 'sop';
                        },
                        msg: 'Креатинфосфатная тренировка',
                    },
                    {
                        is: function (x) {
                            return x === 'kyad';
                        },
                        msg: 'Аэробно-анаэробная тренировка',
                    },
                    {
                        is: function (x) {
                            return x === 'ksd';
                        },
                        msg: 'Лактатная тренировка',
                    },
                    {
                        is: function (x) {
                            return x === 'mixed';
                        },
                        msg: 'Смешанная тренировка',
                    },
                ],
                odv: [
                    {
                        is: function (x) {
                            return x >= 88;
                        },
                        timeMinutes: 25

                    },
                    {
                        is: function (x) {
                            return _.inRange(x, 72, 88);
                        },
                        timeMinutes: 25
                    },
                    {
                        is: function (x) {
                            return _.inRange(x, 56, 72);
                        },
                        timeMinutes: 25
                    },
                    {
                        is: function (x) {
                            return _.inRange(x, 41, 56);
                        },
                        timeMinutes: 45
                    },
                    {
                        is: function (x) {
                            return _.inRange(x, 27, 41);
                        },
                        timeMinutes: 45
                    },
                    {
                        is: function (x) {
                            return _.inRange(x, 11, 27);
                        },
                        timeMinutes: 1000
                    },
                    {
                        is: function (x) {
                            return x < 11;
                        },
                        timeMinutes: 1000
                    }
                ],
                sfp: [
                    {
                        is: function (x) {
                            return x >= 3.70;
                        },
                        rate: 5
                    },
                    {
                        is: function (x) {
                            return _.inRange(x, 3.00, 3.70);
                        },
                        rate: 4
                    },
                    {
                        is: function (x) {
                            return _.inRange(x, 2.30, 3.00);
                        },
                        rate: 3
                    },
                    {
                        is: function (x) {
                            return _.inRange(x, 1.01, 2.30);
                        },
                        rate: 2
                    },
                    {
                        is: function (x) {
                            return x < 1.01;
                        },
                        rate: 1
                    }
                ]
            }
        },
        methods: {
            find() {
                this.selected = '';
                let trainingType = this.trainingType;
                return _.find(this.display, function (d) {
                    return d.is(trainingType);
                });
            }
        }
    }
</script>